@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@use '@helsenorge/designsystem-react/scss/breakpoints' as breakpoints;

.feedbackpanel {
  &__container {
    border-radius: 12px;
    border: 4px solid var(--color-help-graphics);
    background-color: var(--color-action-background-light-normal);
    position: relative;
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: spacers.getSpacer(m);
    padding-top: spacers.getSpacer(s);
    gap: spacers.getSpacer(m);

    @media (min-width: map.get(breakpoints.$grid-breakpoints, md)) {
      padding: spacers.getSpacer(l);
      padding-right: spacers.getSpacer(xl);
    }
  }

  &__title,
  &__expander--title {
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: spacers.getSpacer(s);

    &--text {
      display: flex;
      align-items: flex-start;
      padding-top: spacers.getSpacer(2xs);
      padding-right: spacers.getSpacer(xl);
      gap: spacers.getSpacer(xs);
    }
  }

  &__expander--title {
    justify-content: space-between;

    &--text {
      padding-right: 0;
    }
  }

  &__chevron {
    display: flex;
    align-items: flex-start;
  }

  &__close--button {
    position: absolute;
    width: auto;
    top: spacers.getSpacer(2xs);
    right: spacers.getSpacer(2xs);
  }

  &__buttonrow {
    display: flex;
    gap: spacers.getSpacer(xs);
  }

  &__expander {
    &--content {
      width: 100%;
      background-color: var(--color-action-graphics-light-normal);
      border: none;
      border-radius: 8px;
      cursor: pointer;
      text-align: left;
      padding: spacers.getSpacer(m);
      padding-right: spacers.getSpacer(xs);
      padding-top: spacers.getSpacer(s);

      @media (min-width: map.get(breakpoints.$grid-breakpoints, md)) {
        padding: spacers.getSpacer(l);
        padding-right: spacers.getSpacer(m);
      }

      &:hover {
        background-color: var(--color-help-background-transparent-onlight-hover);
      }

      &:active {
        background-color: var(--color-help-background-transparent-onlight-active);
      }
    }

    &--expandedborder {
      border-radius: 8px 8px 0 0;
    }

    &--expandedcontent {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: spacers.getSpacer(2xs) spacers.getSpacer(xl) spacers.getSpacer(l) spacers.getSpacer(l);
      gap: spacers.getSpacer(m);
    }
  }
}
